import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
  CircularProgress,
  Pagination,
  Typography,
  Button,
  useMediaQuery,
} from "@mui/material";
import { inspectionStatusNewStyleArray } from "../../config";
import moment from "moment";
import { ReactComponent as PassIcon } from "../../../../assets/svg/InspectionSubmitted.svg";
import { ReactComponent as PendingIcon } from "../../../../assets/svg/InspectionScheduled.svg";
import { ReactComponent as FailIcon } from "../../../../assets/svg/InspectionFail.svg";
import styles from "../../styles";
import { getApiData } from "../../../../utils/APIHelper";
import { isEmpty } from "lodash";
import InspectionDetailsModal from "./InspectionDetailsModal";
import { useNavigate, useParams } from "react-router-dom";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  textTransform: "capitalize",
}));

const MobileView = ({
  inspectionDetails,
  handleClick,
  getCapitalizedResultTitle,
  componentStyles,
}) => {
  return (
    <div style={mobileStyles.container}>
      <div style={mobileStyles.inspectionsContainer}>
        {inspectionDetails?.map((item, index) => (
          <div key={item.id} style={mobileStyles.inspectionCard}>
            <Box display="flex" alignItems="center" gap="5px">
              <div style={mobileStyles.milestoneText}>
                <Typography style={mobileStyles.milestoneLabel}>
                  Payment Group
                </Typography>
                <Typography style={mobileStyles.milestoneName}>
                  {item?.groupName}
                </Typography>
              </div>
            </Box>

            <Box display="flex" alignItems="center" gap="5px">
              <div style={mobileStyles.milestoneText}>
                <Typography style={mobileStyles.milestoneLabel}>
                  Milestone
                </Typography>
                <Typography style={mobileStyles.milestoneName}>
                  {item?.milestoneName}
                </Typography>
              </div>
            </Box>

            <div style={mobileStyles.row}>
              <div style={mobileStyles.dateStatusContainer}>
                <div style={mobileStyles.dateItem}>
                  <Typography style={mobileStyles.dateLabel}>
                    Due Date
                  </Typography>
                  <Typography style={mobileStyles.dateValue}>
                    {item?.dueDate
                      ? moment(item?.dueDate).format("DD MMM, YYYY")
                      : "-"}
                  </Typography>
                </div>
                <div style={mobileStyles.statusItem}>
                  <Typography style={mobileStyles.statusLabel}>
                    Status
                  </Typography>
                  <div style={mobileStyles.statusContainer}>
                    <div
                      style={{
                        ...mobileStyles.statusDot,
                        backgroundColor:
                          inspectionStatusNewStyleArray.find(
                            (style) => style.status === item?.status
                          )?.backgroundColor || "#FFAD5C",
                      }}
                    ></div>
                    <Typography style={mobileStyles.statusText}>
                      {getStatusDisplayText(item?.status)}
                    </Typography>
                  </div>{" "}
                </div>
              </div>
            </div>

            <div style={mobileStyles.row}>
              <div style={mobileStyles.inspectionDetailsContainer}>
                <div style={mobileStyles.inspectionItem}>
                  <Typography style={mobileStyles.inspectionLabel}>
                    Inspection Date
                  </Typography>
                  <Typography style={mobileStyles.inspectionValue}>
                    {item?.inspectionDate
                      ? moment(item?.inspectionDate).format("DD MMM, YYYY")
                      : "-"}
                  </Typography>
                </div>
                <div style={mobileStyles.inspectionItem}>
                  <Typography style={mobileStyles.inspectionLabel}>
                    Insp. Status
                  </Typography>
                  <div style={mobileStyles.inspectionStatusContainer}>
                    {item?.result === "PASS" ? (
                      <PassIcon style={mobileStyles.statusIcon} />
                    ) : item?.result === "FAIL" ? (
                      <FailIcon style={mobileStyles.statusIcon} />
                    ) : (
                      <PendingIcon style={mobileStyles.statusIcon} />
                    )}
                    <Typography style={mobileStyles.inspectionStatusText}>
                      {getCapitalizedResultTitle(item?.result)}
                    </Typography>
                  </div>
                </div>
                <div style={mobileStyles.inspectionItem}>
                  <Typography style={mobileStyles.inspectionLabel}>
                    Visit #
                  </Typography>
                  <Typography style={mobileStyles.inspectionValue}>
                    {item?.visit || "-"}
                  </Typography>
                </div>
              </div>
            </div>

            {/* {item?.status === "SUBMITTED" && (
              <div style={mobileStyles.buttonContainer}>
                <Button
                  onClick={() => handleClick(item)}
                  variant="contained"
                  sx={{
                    backgroundColor: "#4D6BF6",
                    borderRadius: "12px",
                    fontSize: "14px",
                    fontWeight: 500,
                    boxShadow: "none",
                    color: "#fff",
                    border: "none",
                    padding: ".7vh 1vw",
                    cursor: "pointer",
                    fontFamily: "Inter Tight",
                    whiteSpace: "nowrap",
                    width: "100% !important",
                    "&:hover": {
                      backgroundColor: "#4D6BF6",
                      border: "none",
                    },
                  }}
                >
                  View Snag Report
                </Button>
              </div>
            )} */}
          </div>
        ))}
      </div>
    </div>
  );
};

const mobileStyles = {
  container: {
    padding: "2vh 0",
    backgroundColor: "#fff",
  },
  inspectionsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
  },
  inspectionCard: {
    backgroundColor: "#fff",
    borderRadius: "none",
    padding: "16px 0",
    borderBottom: "1px solid #D7D8D9",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  row: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  paymentGroupLabel: {
    fontSize: "10px",
    color: "#666",
    marginBottom: "2px",
  },
  paymentGroupName: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
  },
  milestoneLabel: {
    fontSize: "10px",
    color: "#666",
    marginBottom: "2px",
  },
  milestoneName: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
  },
  dateStatusContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "12px",
  },
  dateItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  dateLabel: {
    fontSize: "10px",
    color: "#666",
    marginBottom: "2px",
  },
  dateValue: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "500",
  },
  statusItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  statusLabel: {
    fontSize: "10px",
    color: "#666",
    marginBottom: "2px",
  },
  statusContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  statusDot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    border: "3px solid rgb(229, 229, 229)",
  },
  statusText: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "500",
  },
  inspectionDetailsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "8px",
  },
  inspectionItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  inspectionLabel: {
    fontSize: "10px",
    color: "#666",
    marginBottom: "2px",
  },
  inspectionValue: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "500",
  },
  inspectionStatusContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  statusIcon: {
    width: "16px",
    height: "16px",
  },
  inspectionStatusText: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "500",
  },
  buttonContainer: {
    marginTop: "8px",
  },
};

export default function Inspections({ projectId, isMobile, styles }) {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [inspectionDetails, setInspectionDetails] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(0);

  // Use isMobile prop directly, no fallback needed
  const isMobileDevice = isMobile;

  // Get styles with mobile parameter
  const componentStyles = styles || styles(isMobileDevice);

  useEffect(() => {
    if (projectId) {
      getInspectionDetails();
    }
  }, [projectId, page]);

  async function getInspectionDetails() {
    setLoader(true);
    try {
      const response = await getApiData(
        `api/v2/project/${projectId}/inspections?page=${page}&size=10`,
        "GET",
        {},
        {},
        true
      );
      if (response) {
        console.log("res", response);
        setInspectionDetails(response?.content || []);
        setTotalPages(response?.totalPages || 0);
      }
      setLoader(false);
    } catch (error) {
      console.log("error:===>>>", error);
      setLoader(false);
    }
  }

  const handlePageChange = (event, value) => {
    setPage(value - 1);
  };

  const handleClick = (item) => {
    navigate(`/project/details/${id}/snag/${item.id}`, {
      state: { milestoneDetails: item, styles: componentStyles },
    });
  };

  const getCapitalizedResultTitle = (result) => {
    if (result === "PASS") return "Pass";
    if (result === "FAIL") return "Fail";
    return "Pending";
  };

  if (isMobileDevice) {
    return loader ? (
      <center>
        <CircularProgress />
      </center>
    ) : (
      <>
        {!isEmpty(inspectionDetails) ? (
          <>
            <MobileView
              inspectionDetails={inspectionDetails}
              handleClick={handleClick}
              getCapitalizedResultTitle={getCapitalizedResultTitle}
              componentStyles={componentStyles}
            />
            <center
              style={{
                alignSelf: "center",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                marginTop: "2vh",
              }}
            >
              <Pagination
                count={totalPages}
                page={page + 1}
                onChange={handlePageChange}
                color="primary"
                style={{
                  alignSelf: "center",
                }}
              />
            </center>
          </>
        ) : (
          <center style={{ padding: "2vmax" }}>No inspections found</center>
        )}
        {selectedRow && (
          <InspectionDetailsModal
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
          />
        )}
      </>
    );
  }

  return loader ? (
    <center>
      <CircularProgress />
    </center>
  ) : (
    <>
      {!isEmpty(inspectionDetails) ? (
        <TableContainer
          component={Paper}
          sx={{
            width: "100%",
            overflow: "visible",
            boxShadow: "none",
            marginTop: "2vh",
          }}
        >
          <Table
            sx={{
              "& thead": {
                "& th": {
                  color: "#949DAA",
                  fontWeight: "500",
                },
              },
              "& tbody": {
                "& tr:hover": {
                  backgroundColor: "#f7f7f7",
                },
                "& tr": {
                  borderBottom: "none",
                },
              },
            }}
          >
            <TableHead>
              <TableRow>
                <StyledTableCell>Milestone Name</StyledTableCell>
                <StyledTableCell>Payment Group Name</StyledTableCell>
                <StyledTableCell>Due Date</StyledTableCell>
                <StyledTableCell>Inspection Date</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>Insp. Status</StyledTableCell>
                <StyledTableCell>Visit #</StyledTableCell>
                <StyledTableCell>Action</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {inspectionDetails?.map((item, idx) => (
                <>
                  <TableRow key={item.id}>
                    <StyledTableCell>
                      <Box display="flex" alignItems="center">
                        <span>{item?.milestoneName}</span>
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Box display="flex" alignItems="center">
                        <span>{item?.groupName}</span>
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>
                      <p style={componentStyles.greyRow}>
                        {item?.dueDate
                          ? moment(item?.dueDate).format("MMM DD, YYYY")
                          : "-"}
                      </p>
                    </StyledTableCell>
                    <StyledTableCell>
                      <p style={componentStyles.greyRow}>
                        {item?.inspectionDate
                          ? moment(item?.inspectionDate).format("MMM DD, YYYY")
                          : "-"}
                      </p>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Box
                          sx={{
                            width: "15px",
                            height: "15px",
                            borderRadius: "50%",
                            border: "3px solid rgb(229, 229, 229)",
                            backgroundColor:
                              inspectionStatusNewStyleArray.find(
                                (style) => style.status === item?.status
                              )?.backgroundColor || "#FFAD5C",
                          }}
                        />
                        <Box
                          sx={{
                            fontSize: "14px",
                            color: "#0D0D0E",
                          }}
                        >
                          {getStatusDisplayText(item?.status)}
                        </Box>
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{ paddingLeft: "2.5vw !important" }}
                      title={getCapitalizedResultTitle(item?.result)}
                    >
                      {item?.result === "PASS" ? (
                        <PassIcon />
                      ) : item?.result === "FAIL" ? (
                        <FailIcon />
                      ) : (
                        <PendingIcon />
                      )}
                    </StyledTableCell>
                    <StyledTableCell sx={{ paddingLeft: "2vw !important" }}>
                      {item?.visit || "-"}
                    </StyledTableCell>
                    {item?.status === "SUBMITTED" && (
                      <StyledTableCell>
                        <button
                          onClick={() => handleClick(item)}
                          style={componentStyles.milestoneBtn}
                        >
                          View Snag Report
                        </button>
                      </StyledTableCell>
                    )}
                  </TableRow>
                </>
              ))}
            </TableBody>
          </Table>
          <center
            style={{
              alignSelf: "center",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            <Pagination
              count={totalPages}
              page={page + 1}
              onChange={handlePageChange}
              color="primary"
              style={{
                alignSelf: "center",
                marginTop: "1vh",
              }}
            />
          </center>
        </TableContainer>
      ) : (
        <center style={{ padding: "2vmax" }}>No inspections found</center>
      )}
      {selectedRow && (
        <InspectionDetailsModal
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
        />
      )}
    </>
  );
}
